module.exports = __webpack_public_path__ + "img/logo.efcb4fbf.png";